import React from "react";

export default function VSCode() {
  return (
    <iframe
      className="h-full w-full bg-vscode"
      src="https://github1s.com/chirag3003/chirag3003/blob/main/README.md"
      frameBorder="0"
      title="VSCode"
    />
  );
}
